import * as React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import DownloadingIcon from "@mui/icons-material/Downloading";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Box,
  Button,
  Container,
  FormControl,
  IconButton,
  ImageListItemBar,
  Input,
  InputAdornment,
  InputLabel,
  ListSubheader,
  Modal,
  OutlinedInput,
  Typography,
} from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  bgcolor: "background.paper",
  border: "2px solid transparent",
  boxShadow: 24,
  p: 2,
  borderRadius: "5px",
  outline: "none",
};

export default function QuiltedImageList() {
  const [open, setOpen] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const [pdf, setPdf] = React.useState("");
  const [val, setVal] = React.useState("");

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  function handleClickOpenPdf(item: any) {
    // window.open(item?.pdf, "_blank");
    setOpen(true);
    setPdf(item?.pdf);
  }

  function handleClickOpen(item: any) {
    if (val === "123@neurolink") {
      window.open(pdf, "_blank");
      setOpen(false);
      setVal("");
    } else {
      alert("Parol noto'g'ri");
      setVal("");
    }
  }
  return (
    <Container id="articles" sx={{ pt: { xs: 4 } }}>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={{ ...style, width: 600 }}>
          <Typography
            component="h2"
            variant="h4"
            gutterBottom
            sx={{ color: "text.primary", fontSize: "16px" }}
          >
            Ushbu materiallar mualliflik huquqi bilan himoyalangan. Ularni faqat
            ruxsat berilgan shaxslar ko‘rishlari mumkin. Iltimos, davom etish
            uchun parolni kiriting.
          </Typography>
          <FormControl sx={{ width: "100%" }} variant="standard">
            <InputLabel htmlFor="standard-adornment-password">Parol</InputLabel>
            <Input
              value={val}
              id="standard-adornment-password"
              type={showPassword ? "text" : "password"}
              onChange={(e) => {
                setVal(e.target.value);
              }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label={
                      showPassword
                        ? "hide the password"
                        : "display the password"
                    }
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    onMouseUp={handleMouseUpPassword}
                    sx={{
                      border: "none !important",
                      background: "none !important",
                    }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: "space-between",
              mt: 4,
            }}
          >
            <Button
              variant="outlined"
              color="error"
              size="small"
              sx={{
                minWidth: "fit-content",
                width: { xs: "100%", sm: "200px" },
                height: "47px",
              }}
              onClick={() => setOpen(false)}
            >
              Bekor qilish
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              sx={{
                minWidth: "fit-content",
                width: { xs: "100%", sm: "200px" },
                height: "47px",
              }}
              onClick={handleClickOpen}
            >
              Tasdiqlash
            </Button>
          </Box>
        </Box>
      </Modal>
      <Box
        sx={{
          width: { sm: "100%", md: "60%" },
          textAlign: { sm: "left", md: "center" },
          margin: "0 auto",
        }}
      >
        <Typography component="h2" variant="h4" gutterBottom>
          Maqolalar
        </Typography>
        <Typography variant="body1" sx={{ color: "grey.400" }}>
          Ilmiy-tadqiqotlar hamda maqolalar
        </Typography>
      </Box>
      <ImageList variant="masonry" cols={3} gap={20} sx={{ mt: 4 }}>
        {itemData.map((item) => (
          <ImageListItem
            key={item.img}
            onClick={() => handleClickOpenPdf(item)}
            sx={{
              borderRadius: "10px",
              overflow: "hidden",
              cursor: "pointer",
            }}
          >
            <img
              srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
              src={`${item.img}?w=248&fit=crop&auto=format`}
              alt={item.title}
              loading="lazy"
              style={{ borderRadius: "10px", border: "1.5px solid gray" }}
            />
            <Box>
              <Typography
                sx={{
                  color: "grey.500",
                  fontSize: {
                    xs: "10px",
                    sm: "20px",
                    fontWeight: "500",
                  },
                  fontWeight: "500",
                  mt: "15px",
                  mb: "10px",
                }}
              >
                {item.title}
              </Typography>
            </Box>
            {/* <ImageListItemBar
              title={item.title}
              actionIcon={
                <Box sx={{ cursor: "pointer", marginRight: "8px" }}>
                  <DownloadingIcon
                    sx={{ color: "rgba(255, 255, 255, 0.54)" }}
                  />
                </Box>
              }
            /> */}
          </ImageListItem>
        ))}
      </ImageList>
    </Container>
  );
}

const itemData = [
  {
    img: "assets/art5.png",
    title:
      "Bilingv bolalar nutqidagi agrammatizmlarning psixolingvistik asoslari ",
    pdf: "assets/pdf1.pdf",
  },
  {
    img: "/assets/study.jpg",
    title:
      "Oliy ta’limni tashkil etishda xorijiy tajribalar: transformatsiya va innovatsiyalar",
    pdf: "assets/oliy_TALIM.pdf",
  },
  {
    img: "assets/img51.jpg",
    title:
      "A.R. Luriyaning nutqiy patologiyalarni tashxislashga doir qarashlari tahlili",
    pdf: "assets/file53.pdf",
  },
  {
    img: "assets/img50.jpg",
    title:
      "NUTQ TUSHUNCHASINING NAZARIY ASOSLANISHI PSIXOLINGVISTIKADAGI XATOLAR",
    pdf: "assets/50.Zokirova S.M., Mullagaziyeva S.A. Theoretical substantiation of the concept of speech errors in psycholinguistics.pdf",
  },
  {
    img: "assets/art2.png",
    title:
      "A.R.Luriyaning nutqiy patologiyalarni tashxislashga doir qarashlari tahlili ",
    pdf: "assets/neyrolingvistikaning_nazariy.pdf",
  },

  {
    img: "assets/art3.jpg",
    title: "Neyrolingvistikaning nazariy asoslari va metodlari",
    pdf: "assets/neyrolingvistikaning_nazariy.pdf",
  },

  {
    img: "/assets/fast-reading.webp",
    title: "O'qish tezligi va matnni tushunish",
    pdf: "assets/oqish_va_tushunish.pdf",
  },

  {
    img: "assets/art1.png",
    title: "Til va ong munosabati l.s. vigotskiĭ psixologik talqinida",
    pdf: "assets/til_va_ong.pdf",
  },

  {
    img: "assets/img2.webp",
    title:
      "Maktabgacha ta'limdagi subyektiv baholash: pedagogik va psixologik qarashlar",
    pdf: "assets/file1.pdf",
  },
  {
    img: "assets/img3.jpg",
    title:
      "O‘qish faoliyatining neyropsixolingvistik mexanizmlari: tezlik va tushunish o‘rtasidagi bog‘liqlik",
    pdf: "assets/file2.pdf",
  },
  {
    img: "assets/img4.jpeg",
    title:
      "Neyropsixolingvistika nuqtayi nazaridan nutq buzilishlarining miya faoliyati bilan aloqasi",
    pdf: "assets/file3.pdf",
  },

  {
    img: "assets/img5.png",
    title: "Afaziya turlari tahliliga neyropsixolingvistik yondashuv",
    pdf: "assets/file4.pdf",
  },

  {
    img: "assets/img6.png",
    title: "Akustik-mnestik afaziyaga lingvistik yondashuv",
    pdf: "assets/file3.pdf",
  },

  {
    img: "assets/img8.jpg",
    title: "Afaziya holatlarini o‘rganishda neyrolingvistik yondashuv",
    pdf: "assets/file4.pdf",
  },

  {
    img: "assets/img9.webp",
    title:
      "O‘qish faoliyatining neyropsixolingvistik mexanizmlari: tezlik va tushunish o‘rtasidagi bog‘liqlik",
    pdf: "assets/file5.pdf",
  },

  {
    img: "assets/img10.jpg",
    title: "Qo'qon dpi ilmiy xabarlari jurnali",
    pdf: "assets/file6.pdf",
  },
  {
    img: "assets/img7.JPG",
    title:
      "Neyrolingvistikaning fanlararo ufqlari: Neyrobiologiyadan sun’iy intellektgacha",
    pdf: "assets/file7.pdf",
  },
  {
    img: "assets/img11.jpg",
    title: "Neyrolingvistik Dasturlashning Iste’molchi Ongiga Ta’siri",
    pdf: "assets/file8.pdf",
  },
  {
    img: "assets/img1.webp",
    title: "Disleksiya va disgrafiyaga o‘zbek tilshunosligi asosida yondashuv",
    pdf: "assets/file9.pdf",
  },
  {
    img: "assets/img12.jpg",
    title:
      "Migratsiya ta’siri ostidagi oilalar: Yolg‘iz qolgan keksalarning ijtimoiy himoyasi va turmush sifati",
    pdf: "assets/file10.pdf",
  },

  {
    img: "assets/img13.jpg",
    title:
      "Talabalar Yozuv Malakasini Oshirishda Ijtimoiy Tarmoqlardagi Tuzatuvchi Fikrlar Ro‘li",
    pdf: "assets/file11.pdf",
  },

  {
    img: "assets/img16.jpg",
    title:
      "Onlayn platformalar (Coursera, edX, Khan Academy) orqali ochiq ta’lim imkoniyatlar",
    pdf: "assets/file12.pdf",
  },
  {
    img: "assets/img17.jpg",
    title:
      "Neyropsixolingvistika – zamonaviy tilshunoslikning ilg‘or yo‘nalishi",
    pdf: "assets/file13.pdf",
  },
  {
    img: "assets/img14.jpg",
    title:
      "O‘zbekistonda Ingliz Tilini Rivojlantirish Siyosati: Imkoniyatlar va Muammolar Tahlili",
    pdf: "assets/file14.pdf",
  },
  {
    img: "assets/img18.jpeg",
    title: "Tilshunoslikning zamonaviy yo‘nalishlari",
    pdf: "assets/file15.pdf",
  },
  {
    img: "assets/img19.png",
    title:
      "Neyropsixolingvistika tadqiqotlarining shakllanishi va rivojlanish bosqichlari",
    pdf: "assets/file16.pdf",
  },
  {
    img: "assets/img20.jpg",
    title:
      "Ona tili va xorijiy tildagi tafakkur: til va ong munosabatining falsafiy va lingvistik tahlili",
    pdf: "assets/file17.pdf",
  },

  {
    img: "assets/img21.png",
    title: "Til va adabiyot",
    pdf: "assets/file18.pdf",
  },
  {
    img: "assets/img22.jpg",
    title: "Bolalar nutqining shakllanishi va psixolingvistik omillari",
    pdf: "assets/file19.pdf",
  },
  {
    img: "assets/img.23.jpg",
    title:
      "Tillararo ibora moslashtirish: O‘zbek va Ingliz tillarining grammatik farqlari asosida tahlil",
    pdf: "assets/file20.pdf",
  },
  {
    img: "assets/img15.jpg",
    title:
      "Yosh O‘quvchilarning Nutqiy Faolligini Metafora O‘qitish orqali Innovatsion Yondashuv Bilan Rivojlantirish",
    pdf: "assets/file21.pdf",
  },
  {
    img: "assets/img24.jpg",
    title:
      "Iboralarni Til Juftliklarida Moslashtirish: Aligner Asbobining Lingvistik Platformasi",
    pdf: "assets/file22.pdf",
  },
  {
    img: "assets/img25.jpg",
    title: "LISONIY MEROS VA TILSHUNOSLIK TARAQQIYOTI",
    pdf: "assets/file23.pdf",
  },
  {
    img: "assets/img26.jpg",
    title:
      "O'ZBEKISTON RESPUBLIKASI OLIY TA’LIM, FAN VA INNOVATSIYALAR VAZIRLIGI",
    pdf: "assets/file24.pdf",
  },
  {
    img: "assets/img49.jpg",
    title: "PSİXOLINGVISTIK ASOSLARI RIVOJLANISH NUTQLARI BOLALARDA",
    pdf: "assets/file25.pdf",
  },
  {
    img: "assets/img34.png",
    title: "Rang atamalarining leksik va semantik maydoni: lingvistik tahlil",
    pdf: "assets/file26.pdf",
  },
  {
    img: "assets/img27.jpg",
    title:
      "Neyroximoya Usullarining Tilni Qayta Ishlashdagi Ahamiyati: Ikki Tillilik va Til Buzilishlari Kontekstida Yondashuvlar",
    pdf: "assets/file27.pdf",
  },
  {
    img: "assets/img28.jpg",
    title: "NUTQIY TAFAKKURNING NEYROPSIXOLINGVISTIK TAVSIFI",
    pdf: "assets/file28.pdf",
  },

  {
    img: "assets/img30.jpg",
    title: "Boshlang‘ich yoshdagi bolalarda disleksiya bilan bog‘liq muammolar",
    pdf: "assets/file29.pdf",
  },
  {
    img: "assets/img31.jpg",
    title: "KICHIK YOSHDAGI BOLALARDA DISLEKSIYA BILAN BOG‘LIQ MUAMMOLAR",
    pdf: "assets/file30.pdf",
  },
  {
    img: "assets/img45.jpg",
    title:
      "O‘ZBEKISTON RESPUBLIKASI OLIY TA’LIM, FAN VA INNOVATSIYALAR VAZIRLIGI FARG‘ONA DAVLAT UNIVERSITETI",
    pdf: "assets/file31.pdf",
  },
  {
    img: "assets/img32.jpg",
    title: "BOLALAR NUTQIDAGI AGRAMMATIZMLARNING PSIXOLINGVISTIK ASOSLARI",
    pdf: "assets/file32.pdf",
  },
  {
    img: "assets/img33.jpg",
    title: "Filologiyaning dolzarb masalalari",
    pdf: "assets/file33.pdf",
  },

  {
    img: "assets/img35.avif",
    title: "Til va ong munosabati l.s. vigotskiĭ psixologik talqinida",
    pdf: "assets/file34.pdf",
  },
  {
    img: "assets/img36.webp",
    title:
      "Neyro-lingvistik dasturlash vositalari orqali reklama samaradorligini oshirish",
    pdf: "assets/file35.pdf",
  },
  {
    img: "assets/img37.jpg",
    title: "NLP nima va u qanday ishlaydi?",
    pdf: "assets/file36.pdf",
  },
  {
    img: "assets/img38.jpg",
    title: "Rang toifasi — lingvistik obyekt sifatida",
    pdf: "assets/file37.pdf",
  },

  {
    img: "assets/img48.png",
    title:
      "DISLEKSIYASI BOR BOLALARDA BOSHLANG‘ICH TA’LIM VA SAMARALI O‘QITISH METODOLOGIYASI",
    pdf: "assets/file38.pdf",
  },
  {
    img: "assets/img46.jpg",
    title: "Bolalarda disleksiyaning sabablari, ko'rinishlari va diagnostikasi",
    pdf: "assets/file39.pdf",
  },
  {
    img: "assets/img39.jpg",
    title: "Tilshunoslikda rang atamalarining leksik-semantik tahlili",
    pdf: "assets/file40.pdf",
  },
  {
    img: "assets/img40.jpg",
    title: "Ko‘pma'nolilik: Leksik tizimda semantik tortilish va o‘zgarishlar",
    pdf: "assets/file41.pdf",
  },
  {
    img: "assets/img47.png",
    title:
      "BOSHLANGICH TANISHDAGI BOLALARNI IBRATLI TA'LIM VA SAMARALI O'QITISh METODOLOGIYA",
    pdf: "assets/file42.pdf",
  },
  {
    img: "assets/img41.png",
    title: "Talqin va tadqiqotlar ilmiy-uslubiy jurnali",
    pdf: "assets/file43.pdf",
  },
  {
    img: "assets/img52.webp",
    title: "Til ong tavsifi vositasi sifatida",
    pdf: "assets/file44.pdf",
  },
  {
    img: "assets/img43.jpeg",
    title:
      "Kitobxonlik – intellektual rivojlanish va ma’naviy o‘sishning asosi",
    pdf: "assets/file45.pdf",
  },
  {
    img: "assets/img44.jpg",
    title: "ZAMONAVIY TIL TA'LIMI TIZIMIDA O‘QUVCHILARGA O‘QISHNI O‘RGATISH",
    pdf: "assets/file46.pdf",
  },
  {
    img: "assets/img53.jpg",
    title: "IJTIMOIY lingvistika VA TIL OʻZGARCHILIGI TAHLILI.",
    pdf: "assets/file47.pdf",
  },
  {
    img: "assets/img42.png",
    title: "Lingvistik Qobiliyatlar va Ularning Neyropsixologik Asosi",
    pdf: "assets/file48.pdf",
  },
  {
    img: "assets/img29.jpg",
    title: "Til va ongning o‘zaro ta’siri",
    pdf: "assets/file49.pdf",
  },
];
